import React, { useState } from "react";
import "./../assets/css/login.css";
import logvefase from "./../assets/logok.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import backgroundImage from "./../assets/fondos/zamurai.jpg";

const URL_LOGIN = "https://api.mrcirp.com/public/logininicial";

const Login = () => {
  let navigate = useNavigate();
  const [error, setError] = useState(false);
  const [errordatos, setErrordatos] = useState(false);
  const [espera, setEspera] = useState(false);
  const [Data, setData] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    usuario: "",
    clave: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleLogin = async () => {
    console.log(datosSeleccionados);
    setEspera(true);
    await axios
      .post(URL_LOGIN, datosSeleccionados)
      .then((res) => {
        setData(res.data[0]);
        setError(false);
        setEspera(false);
        console.log(res.data[0]);
        if (res.data[0].error) {
          setErrordatos(true);
        } else if (res.data[0].status === "inactivo") {
          setErrordatos(true);
          setError(true);
          setEspera(false);
        } else {
          window.localStorage.setItem("loginUser", JSON.stringify(res.data[0]));
          if (res.data[0].rol === "cliente") {
            navigate("/iniciouser");
          } else if (res.data[0].rol === "admin") {
            navigate("/inicio");
          }
        }
      })
      .catch((err) => {
        setError(true);
        setEspera(false);
      });
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="bodylogin">
      {/* Imagen de fondo */}
      <div className="video-background">
        <img 
          src={backgroundImage} 
          alt="Background" 
          className="background-image"
        />
      </div>
      
      <div className="container">
        <div className="login-register">
          <div className="row">
            <div className="col-md-4 offset-md-4 col-sm-10 offset-sm-1 mt-4">
              <div className="card login-box">
                <div className="card-body" style={{ textAlign: "left" }}>
                  <div className="form-horizontal form-material text-center">
                    <img src={logvefase} alt="some value" width={200} style={{ maxWidth: '100%', height: 'auto' }} />
                    <div className="form-group ">
                      <div className="col-sm-12 mt-4">
                        <input
                          className="form-control"
                          name="usuario"
                          type="text"
                          required=""
                          placeholder="Usuario o correo electrónico"
                          onChange={handleChange}
                        />{" "}
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="col-sm-12">
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="clave"
                            type={showPassword ? "text" : "password"}
                            required=""
                            placeholder="Password"
                            onChange={handleChange}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={toggleShowPassword}
                            >
                              {showPassword ? (
                                <FaIcons.FaEyeSlash />
                              ) : (
                                <FaIcons.FaEye />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {errordatos && (
                      <div className="alert alert-danger">
                        <h6>Datos de usuario incorrectos o usuario inactivo</h6>
                      </div>
                    )}

                    {error && (
                      <div className="alert alert-danger">
                        <h6>No hay conexión a internet</h6>
                      </div>
                    )}

                    <div className="form-group text-center">
                      <div className="col-xs-12 p-b-20">
                        <button
                          onClick={handleLogin}
                          disabled={espera}
                          style={{
                            backgroundColor: "#165afa",
                            borderColor: "#165afa",
                          }}
                          className="btn btn-block btn-lg text-white"
                        >
                          Entrar
                        </button>
                      </div>
                    </div>
                    <h6 className="mt-4">© KATANA 2025</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;